import { archiveCategories } from "@/mocks/gossip";

const toneChip: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-900",
};

const toneIcon: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export default function Archive() {
  return (
    <section id="archive" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-secondary-500 pl-4">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">分类档案 · Archive</p>
          <h2 className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">挑一个档案柜，慢慢翻</h2>
          <p className="max-w-2xl text-sm text-foreground-600">
            从恋情到塌房，从选秀到豪门，不同维度的吃瓜八卦旧料分门别类，想考古哪一类都方便。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {archiveCategories.map((c) => (
            <a
              key={c.name}
              href="#subscribe"
              className="group flex flex-col rounded-lg border border-background-300/60 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-foreground-900/25"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${toneIcon[c.tone]}`}>
                  <i className={`${c.icon} text-xl`} />
                </span>
                <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${toneChip[c.tone]}`}>{c.count} 篇</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-accent-600">
                {c.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-secondary-700">
                进入档案柜 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}